export { TooltipContainerComponent } from './tooltip.component';
export { TooltipDirective } from './tooltip.directive';
export { MDBTooltipModule } from './tooltip.module';
export { TooltipConfig } from './tooltip.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/tooltip/index.js
// module id = ../../../../angular-bootstrap-md/tooltip/index.js
// module chunks = 3